import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as _ from 'lodash';

import { AppService } from 'src/app/app.service';
import { AuthService } from 'src/app/_core/auth.service';
import { EntityService } from 'src/app/_core/entity.service';
import { DialogsService } from 'src/app/_services/dialogs.service';
import { TabitPayService } from 'src/app/tabit-pay/tabit-pay.service';

import { routerTransition } from 'src/app/_core/static/animations';
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {TipDialogComponent} from "../../tabit-pay/_dialogs/tip-dialog/tip-dialog.component";
import { ValidateCodeDialogComponent } from '../../dialogs/validate-code-dialog/validate-code-dialog.component';

@Component({
    selector: 'app-shared-order-manage',
    templateUrl: './shared-order-manage.component.html',
    styleUrls: ['./shared-order-manage.component.scss'],
    host: {},
    standalone: false
})
export class SharedOrderManageComponent implements OnInit {
	$storage: any;
	loading = false;

	canCreateTabOrder;
	activeTab;

	addToLimitForm: UntypedFormGroup;
	amountText;
	minAmount = 50;
	maxAmount = 5000;
	addToLimitDenoms = [50,100,150,500];

	base: any = {}
	changes: any = {}

	constructor(
		public dialog: MatDialog,
		public appService: AppService,
		public authService: AuthService,
		public entityService: EntityService,
		public dialogsService: DialogsService,
		public tabitPayService: TabitPayService,
		public dialogRef: MatDialogRef<SharedOrderManageComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.$storage = this.tabitPayService.$storage;
		if (this.$storage.order?._order?.deliveryInfo?.reviewItemsBeforeSending) {
			this.base.reviewItemsBeforeSending = true;
		}
		this.changes = _.cloneDeep(this.$storage.order);

		this.canCreateTabOrder = this.tabitPayService.canCreateTabOrder(this.$storage.site);

		this.activeTab = this.$storage.order.authorization;
		if (this.activeTab) {
			this.amountText = this.appService.translate('GROUP_VALIDATION.between_amount', {
				min: this.appService.parseCurrency(this.minAmount),
				max: this.appService.parseCurrency(this.maxAmount)
			})
			this.addToLimitForm = new UntypedFormGroup({
				amountLimit: new UntypedFormControl('', [Validators.required, Validators.pattern('[0-9]*'), Validators.min(50), Validators.max(5000)])
			});
		}

	}

	ngOnInit() { }

	get amountLimit() {
		return this.addToLimitForm.get('amountLimit');
	}

	addToAmountLimit(op) {
		this.amountLimit.setValue((this.amountLimit.value || 0) + op);
	}

	async addAmountLimit(isAdd = true) {
		if (!this.addToLimitForm.valid) {
			_.each(this.addToLimitForm.controls, (val, key) => {
				val.markAsTouched({ onlySelf: true });
			})
			return;
		}
		let order = this.$storage.order;
		let amount = this.addToLimitForm.value.amountLimit + this.$storage.order.tabLimit;
		let surcharge = order.authorization?.processingSurchargeAmount;
		if (surcharge) {
			amount = Math.round(amount - (surcharge / 100)) ;
		}

		this.loading = true;
		let response;
		try {
			response = await this.entityService.updateAuthPayment(order?.order_id, order?.authorization?._id, Math.round(amount * 100));
		} catch (e) {
			this.showPreAuthError(e);
			this.loading = false;
			return;
		}

		this.appService.toastr(this.appService.translate('MESSAGES.LIMIT_UPDATED_SUCCESSFULLY'), {type:'success'});
		this.amountLimit.reset('');

		order.authorization = response;
		order.tabLimit = _.round(_.get(order.authorization, 'amount', 0) / 100, 2);
		this.loading = false;
	}

	async validatePaymentLast4(args) {
		return new Promise((resolve, reject) => {
			const dialogRef = this.dialog.open(ValidateCodeDialogComponent, {
				panelClass: 'rounded-dialog',
				maxWidth: "90vw",
				width: "310px",
				data: args
			});
			dialogRef.afterClosed().subscribe(result => {
				if (result) resolve(result);
				else reject();
			});
		});
	}

	async closeTab() {
		let order= this.$storage.order;
		try {
			await this.appService.confirm({
				html: this.appService.translate('OAT.close_tab_message'),
				confirmText: 'Yes',
				cancelText: 'No',
				enlargeTextButtons: true
			});

			if (order.authorization && order.authorization.last4 && !order.isTabOwner) {
				await this.validatePaymentLast4({
					connectOptions: {
						title: 'OAT.validate_last4_title',
						desc: 'OAT.validate_last4_desc',
					},
					secret: order.authorization.last4
				});
			}

		} catch (e) {
			return;
		}
		let tipAmount = 0;
		await this.showTipDialog({
			orderTotal: order.total,
			balanceDue: order.balanceDue
		}).then(o => {
			if (o && o.amount) tipAmount = Math.round(o.amount * 100);
		});


		let amount = order.balanceDue;
		this.loading = true;
		let response;
		try {
			response = await this.entityService.completeAuthPayment(order?.order_id, order?.authorization?._id, Math.round(amount * 100) + tipAmount, tipAmount);
			console.log(response);
		} catch (e) {
			this.showPreAuthError(e);
			this.loading = false;
			return;
		}
		document.location.reload();
	}

	async addNewTabLimit() {
		let dialogResponse = await this.dialogsService.showKeypadDialog(
			{
				title: "OAT.field_amount_limit",
				currency: this.appService.currency,
				maxVal: 5000,
				minVal: Math.max(this.$storage.order.balanceDue, 100),
				response: { amount: 100, amountText: "" },
				enableDecimals: this.appService.regionArgs.enableDecimals
			}
		);
		if (!dialogResponse) return;
		let amount = dialogResponse["amount"];
		this.loading = true;
		try {
			let response = await this.tabitPayService.addPaymentAuthorization(amount);
			document.location.reload();
		} catch (e) {
			this.showPreAuthError(e);
			this.loading = false;
		}
	}

	async showTipDialog(args): Promise<any> {
		return new Promise((resolve, reject) => {
			let dialogRef = this.dialog.open(TipDialogComponent, {
				width: "340px",
				maxWidth: '95vw',
				panelClass: 'rounded-dialog',
				backdropClass: 'dialog-backdrop-dark',
				direction: this.appService.direction,
				disableClose: true,
				data: { ...args },
				autoFocus: false
			});
			dialogRef.afterClosed().subscribe(result => {
				if (result) {
					if (result === 'CANCEL') return;
					resolve(result);
				} else {
					resolve(null);
				}
			});
		});
	}




	showPreAuthError(err) {
		let errorData = err?.error?.data
		let message = 'error_general';
		switch (errorData?.code) {
			case 409947 :
				message = 'OAT.action_in_progress_error';
				break;
		}
		this.appService.alert({content:message});
	}


	cancel() {
		this.dialogRef.close();
	}

}
